import React from "react";

// =============== 随机图片组件开始 ===============
// 通过 picsum.photos 根据指定宽高返回随机图片
// props:
//   width: 宽度（必填）
//   height: 高度（必填）
//   className: 额外样式
//   alt: 图片 alt 文本，默认 "random-image"
// ===============================================

type RandomImageProps = {
  width: number;
  height: number;
  className?: string;
  alt?: string;
};

import { cn } from "@/lib/utils";

export default function RandomImage({
  width,
  height,
  className = "",
  alt = "random-image",
}: RandomImageProps) {
  // 使用随机种子避免浏览器缓存，可用 Date.now()
  const seed = Math.floor(Math.random() * 100000);
  const url = `https://picsum.photos/seed/${seed}/${width}/${height}`;
  return (
    <img
      src={url}
      width={width}
      height={height}
      alt={alt}
      className={cn("w-full h-full object-cover", className)}
    />
  );
}

// =============== 随机图片组件结束 ===============
